(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-delivery-zone-checker"]) return;
  try {
    
// Section-Builder: 01-main.js
const HEADERS = {
    'User-Agent': 'CupcakeCentral/1.0 (rohit@cupcakecentral.com.au)',
  };
  const _LOADING = 'data-loading';
  const _SUCCESS = 'data-success';
  const _FAILURE = 'data-failure';

  /**
   * @typedef {Object} PostcodeInfo
   * @property {Set<string>} postcodes - Queriable set of postcodes.
   * @property {string} fee - The fee associated with the postcode.
   */

  /**
   * @typedef {Object} ExtractedAddress
   * @property {string} postcode - The extracted postcode.
   * @property {string} address - The remaining address without country/state.
   */

  class ZoneChecker extends HTMLElement {
    #form;
    #locationSpan;
    #extraInfoSpan;
    /** @type {PostcodeInfo[]} */
    #postcodeInfo = [];

    constructor() {
      super();

      this.#form = /** @type {HTMLFormElement} */ (this.throw.element('form'));
      this.#locationSpan = this.throw.element('[data-location]');
      this.#extraInfoSpan = this.throw.element('[data-name=extra-info]');
      const dataDivs = this.throw.any('[data-name=postcode-data]');
      dataDivs.forEach((element) => {
        const postcode = element.getAttribute('data-postcodes');
        const fee = element.getAttribute('data-fee');
        if (!postcode || !fee) {
          throw Error(`Missing postcode or fee for element: ${element.outerHTML}`);
        }
        const postcodeSet = new Set(postcode?.split(',').map((code) => code.trim()) ?? []);
        this.#postcodeInfo.push({
          postcodes: postcodeSet,
          fee: fee,
        });
      });

      this.#addFormListener();
      this.#backListener();
    }

    #backListener() {
      this.throw.element('[data-reset]').addEventListener('click', () => {
        this.removeAttribute(_SUCCESS);
        this.removeAttribute(_FAILURE);
      });
    }

    #addFormListener() {
      this.#form?.addEventListener('submit', async (e) => {
        const event = /** @type {SubmitEvent} */ (e);
        const eventTarget = /** @type {HTMLFormElement} */ (event.target);

        event.preventDefault(); // No reload.
        this.setAttribute(_LOADING, '');

        try {
          const formData = new FormData(eventTarget);
          const userInput = formData.get('user-postcode')?.toString().trim();

          if (userInput === undefined || userInput === '') return;

          const result = await queryNominatim(userInput).catch((error) => {
            console.error(error);
            return null;
          });

          if (!result) {
            this.setAttribute(_FAILURE, '');
            logMissingPostcode(userInput);
          } else {
            const { postcode, address } = result;
            const { ok, fee } = this.#checkPostcode(postcode);
            if (ok) {
              this.#locationSpan.textContent = address;
              this.#extraInfoSpan.textContent = fee;
              this.setAttribute(_SUCCESS, '');
            } else {
              this.setAttribute(_FAILURE, '');
              logMissingPostcode(userInput);
            }
          }
        } finally {
          this.removeAttribute(_LOADING);
        }
      });
    }

    #checkPostcode(postcode) {
      for (const info of this.#postcodeInfo) {
        if (info.postcodes.has(postcode)) {
          return {
            ok: true,
            fee: info.fee,
          };
        }
      }
      return {
        ok: false,
        fee: null,
      };
    }
  }

  customElements.define('zone-checker', ZoneChecker);

  /**
   * Extracts the postcode from the given query string.
   * @param {string} query - The query string to extract the postcode from.
   * @returns {ExtractedAddress|null} - The extracted postcode and address, or null if not found.
   */
  function extractPodcode(query) {
    const components = query.split(',').map((c) => c.trim());
    let postcode = null;
    for (const component of components) {
      const postcodeMatch = component.match(/(\d{4})(?=[,\s]|$)/);
      if (postcodeMatch) {
        postcode = postcodeMatch[1];
      }
    }
    if (!postcode) return null;
    const address = components
      .filter((component) => {
        return !(component.includes('Australia') || component.includes('Victoria') || component.includes('Melbourne'));
      })
      .join(', ');

    return { postcode, address };
  }

  /**
   * Extracts the label from the Nominatim API response.
   * @param {Object} data - The response data from the Nominatim API.
   * @returns {string | null} - The extracted label, or null if not found.
   */
  function extractNominatimLabel(data) {
    let label = null;
    for (const feature of data.features) {
      const type = /** @type {string | undefined} */ (feature.properties?.geocoding?.type);
      if (type === 'district' || type === 'locality' || type === 'state') {
        label = /** @type {string} */ (feature.properties?.geocoding?.label);
        if (!label) throw new Error('No label found');
        break;
      }
    }
    return label;
  }

  /**
   * Queries the Nominatim API for the given address.
   * @param {string} address - The address to query.
   * @returns {Promise<{ postcode: string; address: string }|null>} - The extracted postcode and address, or null if not found.
   */
  async function queryNominatim(address) {
    const query = encodeURIComponent(address);
    const url = `https://nominatim.openstreetmap.org/search?format=geocodejson&q=${query},+Victoria&countrycodes=au&limit=5`;
    const response = await fetch(url, { headers: HEADERS });
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const data = await response.json();
    const label = extractNominatimLabel(data);
    if (!label) {
      return null;
    }
    return extractPodcode(label);
  }

  /** Logs a missing postcode to the Google Sheets spreadsheet.
   *
   * @param {string} postcode The postcode to log.
   */
  async function logMissingPostcode(postcode) {
    const url = `https://nominatim.openstreetmap.org/search?format=geocodejson&q=${postcode}&countrycodes=au&limit=5`;
    const response = await fetch(url, { headers: HEADERS });
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const data = await response.json();
    const label = extractNominatimLabel(data);
    const encPostcode = encodeURIComponent(postcode);
    const address = encodeURIComponent(label ?? '');
    await fetch(
      'https://script.google.com/macros/s/AKfycbxKp4Oc-_NXQuoP4THu6Wrd8B1AbtXWLbcnKLrmHgxDwBzzJraSoP_B1X0JGjzzSdbe/exec',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `postcode=${encPostcode}&address=${address}`,
      },
    ).catch(console.error);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-ordering-guide"]) return;
  try {
    
// Section-Builder: 01-main.js
class OrderTracker extends HTMLElement {
    #progress = 0;
    #nodes;
    #trackFill;
    #segCount;
    #truckWrap;
    #popped = new Set();
    onScrollFn;

    constructor() {
      super();
      this.onScrollFn = this.#onScroll.bind(this);
      this.#nodes = Array.from(this.throw.any('[data-name="node"]'));
      this.#trackFill = this.throw.element('[data-name="track-fill"]');
      this.#truckWrap = this.throw.element('[data-name="truck-wrap"]');
      this.#segCount = this.#nodes.length - 1;
    }

    connectedCallback() {
      window.addEventListener('scroll', this.onScrollFn, { passive: true });
      window.addEventListener('resize', this.onScrollFn);
      this.onScrollFn();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollFn);
      window.removeEventListener('resize', this.onScrollFn);
    }

    #onScroll() {
      const rect = this.getBoundingClientRect();
      const start = window.innerHeight * 0.8;
      const end = window.innerHeight * 0.3;

      const raw = (start - rect.top) / (start - end);
      const clamped = Math.min(1, Math.max(0, raw));
      if (Math.abs(clamped - this.#progress) > 0.0005) {
        this.#progress = clamped;
        this.#update();
      }
    }

    #update() {
      const overall = this.#progress * this.#segCount; // 0..segCount
      const width = this.offsetWidth;
      const x = width * this.#progress;

      this.#trackFill.style.width = `${this.#progress * 100}%`;
      const trackWidth = this.#trackFill.offsetWidth;
      const truckWidth = this.#truckWrap.offsetWidth;
      this.#truckWrap.style.transform = `translateX(${trackWidth - truckWidth / 2}px)`;

      this.#nodes.forEach((node, i) => {
        const reached = overall >= i - 0.001;
        const isLast = i === this.#segCount;

        node.toggleAttribute('data-reached', reached);
        node.dataset.last = isLast ? 'true' : 'false';

        const check = node.throw.element('svg[data-name="check"]');

        if (reached) {
          // Determine if the checkmark should show & pop
          const showCheck = !isLast || overall >= this.#segCount - 0.001;

          if (showCheck) {
            if (!this.#popped.has(i)) {
              check.classList.add('pop-in');
              this.#popped.add(i);
            }
          } else {
            check.classList.remove('pop-in');
          }
        } else {
          check.classList.remove('pop-in');
          this.#popped.delete(i);
        }
      });
    }
  }

  customElements.define('order-tracker', OrderTracker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-our-story"]) return;
  try {
    
// Section-Builder: 01-main.js
const SPEED = 0.4;

  class TextAutoScroller extends HTMLElement {
    #track;
    constructor() {
      super();
      this.#track = document.body.throw.element('[data-scroll-text]');
    }

    connectedCallback() {
      window.addEventListener(
        'scroll',
        () => {
          const offset = -(window.scrollY * SPEED) % this.#track.scrollWidth;
          this.#track.style.transform = `translateX(${offset}px)`;
        },
        { passive: true },
      );
    }
  }

  customElements.define('text-auto-scroller', TextAutoScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-scrolling-text"]) return;
  try {
    
// Section-Builder: 01-main.js
const SPEED = 0.4;

  class TextAutoScroller extends HTMLElement {
    #track;
    constructor() {
      super();
      this.#track = document.body.throw.element('[data-scroll-text]');
    }

    connectedCallback() {
      window.addEventListener(
        'scroll',
        () => {
          const offset = -(window.scrollY * SPEED) % this.#track.scrollWidth;
          this.#track.style.transform = `translateX(${offset}px)`;
        },
        { passive: true },
      );
    }
  }

  customElements.define('text-auto-scroller', TextAutoScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-popup"]) return;
  try {
    
// Section-Builder: 01-main.js
class CartPopup extends HTMLElement {
    /** @type {HTMLDialogElement} */
    #popup;
    #popupSurface;
    /** @type {(event: Event) => void} */
    #preventClose;

    constructor() {
      super();
      this.#popup = /** @type {HTMLDialogElement} */ (this.throw.byId('cart-popup-section'));
      this.#popupSurface = this.#popup.throw.element('[data-name="popup-surface"]');
      this.#preventClose = this.preventClose.bind(this);
    }

    connectedCallback() {
      document.body.addEventListener('click', (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        const targetId = target.getAttribute('id');
        if (targetId === 'cart-popup-section') {
          this.handleClose();
          return;
        }
        if (target.closest('#cart-show-button')) {
          this.handleOpen();
          return;
        }
      });
    }

    startZapiet() {
      document.body.addEventListener(
        'hx:after-swap',
        () => {
          // @ts-ignore
          Zapiet.start(ZapietCachedSettings);
          setTimeout(() => {
            // @ts-ignore
            if (Zapiet.Widget.checkoutEnabled() === undefined) {
              // @ts-ignore
              Zapiet.start(ZapietCachedSettings);
            }
          }, 2000);
        },
        { once: true },
      );
    }

    /**
     * Prevents the popup from closing when the user cancels or pops the history state.
     * @param {Event} event - The cancel or popstate event.
     */
    preventClose(event) {
      event.preventDefault();
      this.handleClose();
    }

    handleOpen() {
      const element = this.#popup.querySelector('#cart-main-layout');
      const form = element instanceof HTMLFormElement ? element : null;
      if (form) {
        form.requestSubmit();
        this.startZapiet();
      }
      this.#popup.showModal();
      requestAnimationFrame(() => {
        this.#popupSurface.dataset.show = String(true);
      });
      history.pushState({ modal: true }, '', window.location.href);
      window.addEventListener('popstate', this.#preventClose);
      document.body.addEventListener('cancel', this.#preventClose);
    }

    handleClose() {
      this.#popupSurface.dataset.show = String(false);
      this.#popupSurface.addEventListener('transitionend', () => this.#popup.close(), { once: true });
      window.removeEventListener('popstate', this.#preventClose);
      document.body.removeEventListener('cancel', this.#preventClose);
      // Only go back if there's a modal state
      if (history.state?.modal) {
        history.back();
      }
    }
  }

  customElements.define('cart-popup', CartPopup);

  class UpdateCartRefresh extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'hx:after-swap',
        () => {
          const form = /** @type {HTMLFormElement} */ (this.querySelector('form'));
          form.setAttribute('hx-swap', 'cart-icon-bubble cart upsells total-price gift-message-form');
          /** @ts-ignore */
          Zapiet.start(ZapietCachedSettings);
        },
        { once: true },
      );
    }
  }

  customElements.define('update-cart-refresh', UpdateCartRefresh);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-hero"]) return;
  try {
    
// Section-Builder: carousel-strip.js
class CarouselStrip extends HTMLElement {
  /** @type {HTMLElement | null} */
  #track = null;

  /** @type {number} */
  #interval = 3000;

  /** @type {number} */
  #realCount = 0;

  /** @type {number} */
  #index = 1;

  /** @type {boolean} */
  #paused = false;

  /** @type {boolean} */
  #dragging = false;

  /** @type {number} */
  #startX = 0;

  /** @type {number} */
  #dragOffset = 0;

  /** @type {number | undefined} */
  #timer = undefined;

  /** @type {number | undefined} */
  #resumeTimer = undefined;

  connectedCallback() {
    this.#track = this.querySelector("[data-track]");
    if (!this.#track) return;

    this.#interval = parseInt(this.dataset.interval || "3000", 10);
    this.#realCount = this.#track.children.length;

    const first = /** @type {Element} */ (this.#track.children[0]).cloneNode(
      true,
    );
    const last = /** @type {Element} */ (
      this.#track.children[this.#realCount - 1]
    ).cloneNode(true);
    this.#track.appendChild(first);
    this.#track.insertBefore(last, this.#track.children[0]);

    this.#index = 1;
    this.#paused = false;
    this.#dragging = false;
    this.#startX = 0;
    this.#dragOffset = 0;

    this.#setupTrack();
    this.#bindEvents();
    this.#resetAutoplay();
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
    clearTimeout(this.#resumeTimer);
    this.#unbindEvents();
  }

  /** @returns {HTMLElement} */
  get #trackEl() {
    return /** @type {HTMLElement} */ (this.#track);
  }

  /** @returns {number} */
  get #slideWidth() {
    return this.getBoundingClientRect().width;
  }

  #setupTrack = () => {
    this.#trackEl.style.willChange = "transform";
    this.#jumpTo(this.#index, false);
  };

  /**
   * @param {number} index
   * @param {boolean} [animate=true]
   */
  #jumpTo = (index, animate = true) => {
    this.#trackEl.style.transition = animate ? "transform 400ms ease" : "none";
    this.#trackEl.style.transform = `translate3d(${-index * this.#slideWidth}px, 0, 0)`;
  };

  #next = () => {
    if (this.#dragging) return;
    this.#index++;
    this.#jumpTo(this.#index, true);

    if (this.#index === this.#trackEl.children.length - 1) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = 1;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    }
  };

  #resetAutoplay = () => {
    clearInterval(this.#timer);
    if (!this.#paused) {
      this.#timer = window.setInterval(this.#next, this.#interval);
    }
  };

  #pauseThenResume = () => {
    this.#paused = true;
    clearInterval(this.#timer);
    clearTimeout(this.#resumeTimer);
    this.#resumeTimer = window.setTimeout(() => {
      this.#paused = false;
      this.#resetAutoplay();
    }, this.#interval);
  };

  /**
   * @param {PointerEvent} e
   */
  #handlePointerDown = (e) => {
    e.preventDefault();
    this.#dragging = true;
    this.#paused = true;
    clearInterval(this.#timer);
    this.#startX = e.clientX;
    this.#trackEl.style.transition = "none";
    this.style.cursor = "grabbing";
    this.setPointerCapture(e.pointerId);
  };

  /**
   * @param {PointerEvent} e
   */
  #handlePointerMove = (e) => {
    if (!this.#dragging) return;
    this.#dragOffset = e.clientX - this.#startX;
    const base = -this.#index * this.#slideWidth;
    this.#trackEl.style.transform = `translate3d(${base + this.#dragOffset}px, 0, 0)`;
  };

  #handlePointerEnd = () => {
    if (!this.#dragging) return;
    this.#dragging = false;
    this.style.cursor = "grab";

    const threshold = this.#slideWidth * 0.2;
    if (this.#dragOffset < -threshold) {
      this.#index++;
    } else if (this.#dragOffset > threshold) {
      this.#index--;
    }
    this.#dragOffset = 0;
    this.#jumpTo(this.#index, true);

    const lastIdx = this.#trackEl.children.length - 1;
    if (this.#index === lastIdx) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = 1;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    } else if (this.#index === 0) {
      this.#trackEl.addEventListener(
        "transitionend",
        () => {
          this.#index = this.#realCount;
          this.#jumpTo(this.#index, false);
        },
        { once: true },
      );
    }

    this.#pauseThenResume();
  };

  #handleMouseEnter = () => {
    this.#paused = true;
    clearInterval(this.#timer);
  };

  #handleMouseLeave = () => {
    this.#paused = false;
    this.#resetAutoplay();
  };

  #handleResize = () => {
    this.#jumpTo(this.#index, false);
  };

  #bindEvents = () => {
    this.addEventListener("mouseenter", this.#handleMouseEnter);
    this.addEventListener("mouseleave", this.#handleMouseLeave);
    this.addEventListener("pointerdown", this.#handlePointerDown);
    this.addEventListener("pointermove", this.#handlePointerMove);
    this.addEventListener("pointerup", this.#handlePointerEnd);
    this.addEventListener("pointercancel", this.#handlePointerEnd);
    this.addEventListener("pointerleave", this.#handlePointerEnd);
    window.addEventListener("resize", this.#handleResize);
  };

  #unbindEvents = () => {
    this.removeEventListener("mouseenter", this.#handleMouseEnter);
    this.removeEventListener("mouseleave", this.#handleMouseLeave);
    this.removeEventListener("pointerdown", this.#handlePointerDown);
    this.removeEventListener("pointermove", this.#handlePointerMove);
    this.removeEventListener("pointerup", this.#handlePointerEnd);
    this.removeEventListener("pointercancel", this.#handlePointerEnd);
    this.removeEventListener("pointerleave", this.#handlePointerEnd);
    window.removeEventListener("resize", this.#handleResize);
  };
}

customElements.define("carousel-strip", CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-santa"]) return;
  try {
    
// Section-Builder: santa-fly.js
class SantaFly extends HTMLElement {
  #progress = 0; // 0 = start of flight, 1 = end (then resets to 0)
  #lastScrollY = 0;
  #santa;
  #container;
  #ticking = false;
  onScrollFn;

  // tweak these to taste
  #minScale = 0.55; // size at the ends of the flight
  #maxScale = 1; //    size at the top of the arc

  constructor() {
    super();
    this.onScrollFn = this.#onScroll.bind(this);
  }

  connectedCallback() {
    // Query children here, not in the constructor: the constructor can run
    // before the element's children have been parsed.
    this.#santa =
      this.querySelector('[data-name="hand"]') ?? this.firstElementChild;
    const selector = this.getAttribute("container");
    this.#container =
      (selector && this.closest(selector)) || this.parentElement;

    if (this.#santa) this.#santa.style.willChange = "transform";

    this.#lastScrollY = window.scrollY;
    this.#progress = 0;

    window.addEventListener("scroll", this.onScrollFn, { passive: true });
    window.addEventListener("resize", this.onScrollFn);
    this.onScrollFn();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollFn);
    window.removeEventListener("resize", this.onScrollFn);
  }

  // Height of the full 0-180 degree arc as a multiple of Santa's own width.
  // Santa is what the eye measures the arc against, so tying the height to
  // him keeps the hump looking the same however wide the screen (and the
  // flight path) gets. 0.6 = the full arc is 60% as tall as Santa is wide.
  get #arcRatio() {
    const v = parseFloat(this.getAttribute("arc-ratio"));
    return Number.isFinite(v) ? v : 0.6;
  }

  get #tilt() {
    const v = parseFloat(this.getAttribute("tilt"));
    return Number.isFinite(v) ? v : 0.6;
  }

  // Which slice of the half-circle arc (0 = left end, 90 = peak, 180 = right
  // end) Santa actually flies. Default 60 -> 120 is a shallow hump around the
  // peak. Use arc-start="0" arc-end="180" for the old full arc.
  get #arcStart() {
    const v = parseFloat(this.getAttribute("arc-start"));
    return Number.isFinite(v) ? v : 60;
  }

  get #arcEnd() {
    const v = parseFloat(this.getAttribute("arc-end"));
    return Number.isFinite(v) ? v : 120;
  }

  // How fast scrolling pushes him across (1 = one full flight per
  // viewport-height-plus-container of scrolling, same pace as before).
  get #speed() {
    const v = parseFloat(this.getAttribute("speed"));
    return Number.isFinite(v) && v > 0 ? v : 1;
  }

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#measure();
      this.#ticking = false;
    });
  }

  #measure() {
    if (!this.#santa || !this.#container) return;

    const rect = this.#container.getBoundingClientRect();
    const vh = window.innerHeight;

    // Santa always flies the same way, no matter which way you scroll: any
    // scrolling (up or down) pushes him forward. Only advance while the
    // container is on screen.
    const y = window.scrollY;
    const delta = Math.abs(y - this.#lastScrollY);
    this.#lastScrollY = y;

    const inView = rect.bottom > 0 && rect.top < vh;
    if (delta > 0 && inView) {
      this.#progress += (delta / (vh + rect.height)) * this.#speed;
      // Reached the end: snap back to the start.
      if (this.#progress >= 1) this.#progress = 0;
    }

    this.#update(rect);
  }

  #update(containerRect) {
    const p = this.#progress;

    // Host element is never transformed, so its rect is Santa's "natural"
    // position. We assume the hand is centred in the host.
    const hostRect = this.getBoundingClientRect();
    const hostCenterX = hostRect.left + hostRect.width / 2;
    // NOTE: don't use hand.offsetWidth – it's undefined on <svg> elements.
    // The host is sized by its (untransformed) content, so use its width.
    const halfHand = hostRect.width / 2;

    // Angle along the arc for this progress, in radians.
    const a0 = this.#arcStart;
    const a1 = this.#arcEnd;
    const theta = ((a0 + p * (a1 - a0)) * Math.PI) / 180;
    const sin = Math.sin(theta);

    // Slightly larger at the peak, smaller at the ends (adds depth).
    // Normalised so the ends of the chosen slice are always minScale.
    const sinEnds = Math.min(
      Math.sin((a0 * Math.PI) / 180),
      Math.sin((a1 * Math.PI) / 180),
    );
    const depth = sinEnds < 1 ? (sin - sinEnds) / (1 - sinEnds) : 1;
    const scale =
      this.#minScale + Math.max(0, depth) * (this.#maxScale - this.#minScale);

    // Horizontal: right-most centre -> left-most centre of the container,
    // using the *scaled* half-width so Santa stays inside the edges.
    const leftX = containerRect.left + halfHand * this.#minScale - hostCenterX;
    const rightX =
      containerRect.right - halfHand * this.#minScale - hostCenterX;
    const x = rightX + p * (leftX - rightX);

    // Vertical: sine arc. 0 at the peak (90deg), +H at 0/180deg. H is tied
    // to Santa's width (not the screen width) so the hump keeps the same
    // size relative to him on every screen.
    const travel = Math.abs(rightX - leftX) || 1;
    const H = hostRect.width * this.#arcRatio;
    const y = H * (1 - sin);

    // Bank along the path: angle of the tangent (dy/dx).
    // Travel is right-to-left, so measure the slope against the distance
    // covered leftwards: nose dips while descending, lifts while climbing.
    const dx = travel;
    const dy = (-H * Math.cos(theta) * ((a1 - a0) * Math.PI)) / 180;
    const angle = Math.atan2(-dy, dx) * (180 / Math.PI) * this.#tilt;

    this.#santa.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${angle}deg) scale(${scale})`;
  }
}

customElements.define("santa-fly", SantaFly);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-snowflakes"]) return;
  try {
    
// Section-Builder: snowfall.js
class SnowFall extends HTMLElement {
  static observedAttributes = ["target", "to", "rate", "color"];

  static #MAX_DPR = 1.5; // soft dots don't need full retina; big win on phones
  static #MAX_FLAKES = 1500;
  static #AVG_VY = 23; // mean fall speed (px/s), matches #spawn
  static #FADE_ZONE = 120;

  /** @type {HTMLCanvasElement | null} */
  #canvas = null;
  /** @type {CanvasRenderingContext2D | null | undefined} */
  #ctx = null;
  /** @type {Element | null} */
  #target = null;
  /** @type {Array<{x: number, y: number, r: number, vy: number, sway: number, freq: number, phase: number, alpha: number}>} */
  #flakes = [];
  #raf = 0;
  #last = 0;
  #spawnDebt = 0;
  #layoutQueued = false;
  /** @type {ResizeObserver | null} */
  #ro = null;
  /** @type {MediaQueryList} */
  #reduced = matchMedia("(prefers-reduced-motion: reduce)");

  // Snow region (CSS px). Flakes live in region-local coordinates.
  #w = 0;
  #h = 0;
  #pageTop = 0; // region top in page coordinates

  // Canvas backing size (CSS px). Viewport-sized, only ever grows.
  #cssW = 0;
  #cssH = 0;
  #dpr = 1;

  #rate = 6;
  #color = "#fff";

  connectedCallback() {
    this.#canvas ??= this.querySelector("canvas");
    this.#ctx ??= this.#canvas?.getContext("2d");

    this.#ro = new ResizeObserver(() => this.#queueLayout());
    this.#ro.observe(document.documentElement);
    this.#ro.observe(document.body);
    addEventListener("resize", this.#queueLayout);
    document.addEventListener("visibilitychange", this.#onVisibility);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.#resolve(), {
        once: true,
      });
    } else {
      this.#resolve();
    }
  }

  disconnectedCallback() {
    this.#stop();
    this.#ro?.disconnect();
    removeEventListener("resize", this.#queueLayout);
    document.removeEventListener("visibilitychange", this.#onVisibility);
  }

  attributeChangedCallback() {
    if (this.isConnected) this.#resolve();
  }

  #queueLayout = () => {
    if (this.#layoutQueued) return;
    this.#layoutQueued = true;
    requestAnimationFrame(() => {
      this.#layoutQueued = false;
      this.#layout();
    });
  };

  #onVisibility = () => {
    document.hidden ? this.#stop() : this.#start();
  };

  #resolve() {
    const sel = this.getAttribute("target");
    this.#target = sel ? document.querySelector(sel) : null;
    if (!this.#target) {
      this.#stop();
      throw new Error(`[Snowfall]: no element matches target: ${sel}`);
    }
    this.#rate = parseFloat(this.getAttribute("rate") ?? "") || 6;
    this.#ro?.observe(this.#target);
    this.#layout();
    this.#start();
  }

  #refreshColor() {
    this.#color =
      this.getAttribute("color") ||
      getComputedStyle(this).getPropertyValue("--snow-color").trim() ||
      "#fff";
  }

  #layout() {
    if (!this.#target) return;
    const c = this.#canvas;
    if (!c) {
      throw new Error("[Snowfall]: Canvas is null");
    }

    const t = this.#target.getBoundingClientRect();
    const endSel = this.getAttribute("to");
    const endEl = endSel ? document.querySelector(endSel) : null;

    const pageTop = t.top + scrollY;
    const pageBottom = endEl
      ? endEl.getBoundingClientRect().bottom + scrollY
      : document.documentElement.scrollHeight;

    const w = Math.max(1, Math.round(t.width));
    const h = Math.max(1, Math.round(pageBottom - pageTop) - 1);
    const prevW = this.#w;
    const prevH = this.#h;
    this.#w = w;
    this.#h = h;
    this.#pageTop = pageTop;

    // The canvas only covers the viewport (not the whole page) and never
    // shrinks, so the mobile URL bar collapsing doesn't reallocate it.
    const dpr = Math.min(devicePixelRatio || 1, SnowFall.#MAX_DPR);
    const cssH = Math.max(innerHeight, this.#cssH);
    if (w !== this.#cssW || cssH !== this.#cssH || dpr !== this.#dpr) {
      this.#cssW = w;
      this.#cssH = cssH;
      this.#dpr = dpr;
      c.style.width = w + "px";
      c.style.height = cssH + "px";
      c.width = Math.round(w * dpr);
      c.height = Math.round(cssH * dpr);
      this.#ctx?.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    // Pin the canvas to the viewport at the target's horizontal position,
    // regardless of the containing block.
    c.style.position = "fixed";
    c.style.pointerEvents = "none";
    c.style.left = "0px";
    c.style.top = "0px";
    const origin = c.getBoundingClientRect();
    c.style.left = t.left - origin.left + "px";
    c.style.top = -origin.top + "px";

    this.#refreshColor();

    // Full sky on first layout / width change / newly added height.
    if (w !== prevW) {
      this.#flakes = [];
      this.#prefill(0, h);
    } else if (h > prevH) {
      this.#prefill(prevH, h);
    }
  }

  /**
   * @param {number} fromY
   * @param {number} toY
   */
  #prefill(fromY, toY) {
    const count = Math.round(
      this.#rate * (this.#w / 1000) * ((toY - fromY) / SnowFall.#AVG_VY),
    );
    const room = Math.max(0, SnowFall.#MAX_FLAKES - this.#flakes.length);
    this.#spawn(Math.min(count, room), fromY, toY);
  }

  /**
   * @param {number} count
   * @param {number} [fromY=-4]
   * @param {number} [toY=-4]
   */
  #spawn(count, fromY = -4, toY = -4) {
    for (let i = 0; i < count; i++) {
      this.#flakes.push({
        x: Math.random() * this.#w,
        y: fromY + Math.random() * (toY - fromY),
        r: 0.8 + Math.random() * 2.2,
        vy: 12 + Math.random() * 22, // px/s, lazy
        sway: 6 + Math.random() * 16, // px amplitude
        freq: 0.3 + Math.random() * 0.6, // rad/s
        phase: Math.random() * Math.PI * 2,
        alpha: 0.4 + Math.random() * 0.6,
      });
    }
  }

  #start() {
    if (this.#raf || this.#reduced.matches || !this.#target) return;
    this.#last = performance.now();
    this.#raf = requestAnimationFrame(this.#tick);
  }

  #stop() {
    cancelAnimationFrame(this.#raf);
    this.#raf = 0;
  }

  /** @param {number} now */
  #tick = (now) => {
    const dt = Math.min((now - this.#last) / 1000, 0.1);
    this.#last = now;
    this.#update(dt);
    this.#draw();
    this.#raf = requestAnimationFrame(this.#tick);
  };

  /** @param {number} dt - Delta time in seconds. */
  #update(dt) {
    this.#spawnDebt += this.#rate * (this.#w / 1000) * dt;
    const n = Math.floor(this.#spawnDebt);
    this.#spawnDebt -= n;
    if (this.#flakes.length < SnowFall.#MAX_FLAKES) this.#spawn(n);

    // Update and compact in place (no per-frame array allocation).
    const flakes = this.#flakes;
    const limit = this.#h + 4;
    let j = 0;
    for (let i = 0; i < flakes.length; i++) {
      const f = flakes[i];
      f.y += f.vy * dt;
      f.phase += f.freq * dt;
      if (f.y < limit) flakes[j++] = f;
    }
    flakes.length = j;
  }

  #draw() {
    const ctx = this.#ctx;
    if (!ctx) {
      throw new Error("[Snowflake]: ctx is null");
    }

    ctx.clearRect(0, 0, this.#cssW, this.#cssH);

    // Region-local y of the viewport's top edge; only draw what's on screen.
    const vh = innerHeight;
    const top = scrollY - this.#pageTop;
    if (top > this.#h + 4 || top + vh < -4) return;

    ctx.fillStyle = this.#color;
    const h = this.#h;
    const fadeZone = SnowFall.#FADE_ZONE;
    for (const f of this.#flakes) {
      const y = f.y - top;
      if (y < -4 || y > vh + 4) continue;
      const fade = Math.min(1, (h - f.y) / fadeZone);
      if (fade <= 0) continue;
      ctx.globalAlpha = f.alpha * fade;
      ctx.beginPath();
      ctx.arc(f.x + Math.sin(f.phase) * f.sway, y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  }
}

customElements.define("snow-fall", SnowFall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-ghosts"]) return;
  try {
    
// Section-Builder: scroll-fade.js
/**
 * A web component that fades out all child SVGs when the user scrolls down,
 * then slowly restores their opacity over time.
 *
 * @example
 * <scroll-fade fade-distance="400" recover-time="5">
 *   <svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" /></svg>
 * </scroll-fade>
 *
 * @attr {number} [fade-distance=400] Pixels scrolled down to go from fully visible to invisible.
 * @attr {number} [recover-time=5] Seconds to go from invisible back to fully visible.
 */
class ScrollFade extends HTMLElement {
  /** Current opacity of the SVG, between 0 and 1. @type {number} */
  #opacity = 1;

  /** Vertical scroll position at the previous scroll event. @type {number} */
  #lastScrollY = 0;

  /** Timestamp (ms) of the previous recovery frame. @type {number} */
  #lastTime = 0;

  /** Active requestAnimationFrame id, or null when recovery is idle. @type {number | null} */
  #rafId = null;

  /**
   * Pixels of downward scrolling that take the SVG from opaque to transparent.
   * @type {number}
   */
  get #fadeDistance() {
    return parseFloat(this.getAttribute("fade-distance") ?? "") || 400;
  }

  /**
   * Seconds the SVG takes to recover from transparent to opaque.
   * @type {number}
   */
  get #recoverTime() {
    return parseFloat(this.getAttribute("recover-time") ?? "") || 5;
  }

  /**
   * Every SVG element inside this component (e.g. separate mobile/desktop SVGs).
   * @type {NodeListOf<SVGSVGElement>}
   */
  get #svgs() {
    return this.querySelectorAll("svg");
  }

  /** @returns {void} */
  connectedCallback() {
    this.#lastScrollY = window.scrollY;
    window.addEventListener("scroll", this.#onScroll, { passive: true });
  }

  /** @returns {void} */
  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onScroll);
    this.#stopRecovery();
  }

  /**
   * Fades the SVG proportionally to how far the user scrolled down.
   * Scrolling up has no effect.
   * @type {() => void}
   */
  #onScroll = () => {
    const currentY = window.scrollY;
    const delta = currentY - this.#lastScrollY;
    this.#lastScrollY = currentY;

    if (delta > 0) {
      this.#setOpacity(this.#opacity - delta / this.#fadeDistance);
      this.#startRecovery();
    }
  };

  /**
   * Starts the recovery animation loop if it isn't already running.
   * @returns {void}
   */
  #startRecovery() {
    if (this.#rafId !== null) return;
    this.#lastTime = performance.now();
    this.#rafId = requestAnimationFrame(this.#recoverStep);
  }

  /**
   * Cancels the recovery animation loop.
   * @returns {void}
   */
  #stopRecovery() {
    if (this.#rafId !== null) {
      cancelAnimationFrame(this.#rafId);
      this.#rafId = null;
    }
  }

  /**
   * One frame of the recovery loop. Raises opacity based on elapsed time and
   * stops itself once the SVG is fully visible.
   * @param {DOMHighResTimeStamp} now Timestamp provided by requestAnimationFrame.
   * @returns {void}
   */
  #recoverStep = (now) => {
    const dt = (now - this.#lastTime) / 1000;
    this.#lastTime = now;

    this.#setOpacity(this.#opacity + dt / this.#recoverTime);

    if (this.#opacity < 1) {
      this.#rafId = requestAnimationFrame(this.#recoverStep);
    } else {
      this.#rafId = null;
    }
  };

  /**
   * Clamps the value to [0, 1], stores it, and applies it to every SVG.
   * @param {number} value Desired opacity.
   * @returns {void}
   */
  #setOpacity(value) {
    this.#opacity = Math.min(1, Math.max(0, value));
    for (const svg of this.#svgs) svg.style.opacity = String(this.#opacity);
  }
}

customElements.define("scroll-fade", ScrollFade);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-graveyard"]) return;
  try {
    
// Section-Builder: hand-animation.js
class GraveHand extends HTMLElement {
  #progress = 0;
  #hand;
  #ticking = false;
  onScrollFn;

  // tweak these to taste
  #minScale = 0.55;
  #maxScale = 1;

  constructor() {
    super();
    this.onScrollFn = this.#onScroll.bind(this);
    this.#hand = this.querySelector('[data-name="hand"]');
  }

  connectedCallback() {
    window.addEventListener("scroll", this.onScrollFn, { passive: true });
    window.addEventListener("resize", this.onScrollFn);
    this.onScrollFn();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollFn);
    window.removeEventListener("resize", this.onScrollFn);
  }

  #onScroll() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#measure();
      this.#ticking = false;
    });
  }

  #measure() {
    const rect = this.getBoundingClientRect();
    const start = window.innerHeight * 0.9;
    const end = window.innerHeight * 0.3;

    const raw = (start - rect.top) / (start - end);
    const clamped = Math.min(1, Math.max(0, raw));

    if (Math.abs(clamped - this.#progress) > 0.0005) {
      this.#progress = clamped;
      this.#update();
    }
  }

  #update() {
    // 50% -> 0% as progress goes 0 -> 1
    const translateY = 50 - this.#progress * 40;
    // minScale -> maxScale as progress goes 0 -> 1
    const scale =
      this.#minScale + this.#progress * (this.#maxScale - this.#minScale);

    this.#hand.style.transform = `translateY(${translateY}%) scale(${scale})`;
  }
}

customElements.define("grave-hand", GraveHand);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-hero"]) return;
  try {
    
// Section-Builder: 01-carousel-strip.js
// ---------------------------------------------------------------------------
// Carousel Strip
// ---------------------------------------------------------------------------

class CarouselStrip extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-track]");
    this.interval = parseInt(this.dataset.interval || "3000", 10);

    // real slide count (before cloning)
    this.realCount = this.track.children.length;

    // clone first and last slide for seamless infinite wrap
    const first = this.track.children[0].cloneNode(true);
    const last = this.track.children[this.realCount - 1].cloneNode(true);
    this.track.appendChild(first);
    this.track.insertBefore(last, this.track.children[0]);

    // index 1 = first real slide (index 0 is the cloned "last")
    this.index = 1;
    this.paused = false;
    this.dragging = false;
    this.startX = 0;
    this.dragOffset = 0;

    this._setupTrack();
    this._bindEvents();
    this._resetAutoplay();

    window.addEventListener("resize", () => this._jumpTo(this.index, false));
  }

  disconnectedCallback() {
    clearInterval(this._timer);
    clearTimeout(this._resumeTimer);
  }

  _setupTrack() {
    this.track.style.willChange = "transform";
    this._jumpTo(this.index, false);
  }

  get slideWidth() {
    return this.getBoundingClientRect().width;
  }

  _jumpTo(index, animate = true) {
    this.track.style.transition = animate ? "transform 400ms ease" : "none";
    this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
  }

  _next() {
    if (this.dragging) return;
    this.index++;
    this._jumpTo(this.index, true);

    // if we've landed on the cloned last slide, snap back invisibly
    if (this.index === this.track.children.length - 1) {
      this.track.addEventListener(
        "transitionend",
        () => {
          this.index = 1;
          this._jumpTo(this.index, false);
        },
        { once: true },
      );
    }
  }

  _resetAutoplay() {
    clearInterval(this._timer);
    if (!this.paused) {
      this._timer = setInterval(() => this._next(), this.interval);
    }
  }

  _pauseThenResume() {
    this.paused = true;
    clearInterval(this._timer);
    clearTimeout(this._resumeTimer);
    this._resumeTimer = setTimeout(() => {
      this.paused = false;
      this._resetAutoplay();
    }, this.interval);
  }

  _bindEvents() {
    this.addEventListener("mouseenter", () => {
      this.paused = true;
      clearInterval(this._timer);
    });
    this.addEventListener("mouseleave", () => {
      this.paused = false;
      this._resetAutoplay();
    });

    this.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      this.dragging = true;
      this.paused = true;
      clearInterval(this._timer);
      this.startX = e.clientX;
      this.track.style.transition = "none";
      this.style.cursor = "grabbing";
      this.setPointerCapture(e.pointerId);
    });

    this.addEventListener("pointermove", (e) => {
      if (!this.dragging) return;
      this.dragOffset = e.clientX - this.startX;
      const base = -this.index * this.slideWidth;
      this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
    });

    const endDrag = () => {
      if (!this.dragging) return;
      this.dragging = false;
      this.style.cursor = "grab";

      const threshold = this.slideWidth * 0.2;
      if (this.dragOffset < -threshold) {
        this.index++;
      } else if (this.dragOffset > threshold) {
        this.index--;
      }
      this.dragOffset = 0;
      this._jumpTo(this.index, true);

      // handle wrap-around after manual swipe
      const lastIdx = this.track.children.length - 1;
      if (this.index === lastIdx) {
        this.track.addEventListener(
          "transitionend",
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      } else if (this.index === 0) {
        this.track.addEventListener(
          "transitionend",
          () => {
            this.index = this.realCount;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }

      this._pauseThenResume();
    };

    this.addEventListener("pointerup", endDrag);
    this.addEventListener("pointercancel", endDrag);
    this.addEventListener("pointerleave", endDrag);
  }
}

customElements.define("carousel-strip", CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcement-bar"]) return;
  try {
    
// Section-Builder: 01-main.js
const ANNOUCEMENT_SPEED = 'data-speed';

  class AnnouncementBar extends HTMLElement {
    DURATION = 700;
    EASING = 'cubic-bezier(0.86, 0, 0.07, 1)';

    #track;
    #current = 0;
    #interval = 1000;
    #slides = [];

    constructor() {
      super();
      this.#track = this.throw.element("[data-name='track']");
    }

    connectedCallback() {
      const clone = this.#track.throw.element('[data-name="announcement"]').cloneNode(true);
      this.#track.appendChild(clone);
      this.#slides = Array.from(this.#track.throw.any('[data-name="announcement"]'));

      const transition_speed = this.getAttribute(ANNOUCEMENT_SPEED);
      if (transition_speed) {
        this.#interval = parseInt(transition_speed) * 1000;
      }

      setInterval(() => this.advance(), this.#interval);
    }
    /**
     * Enable or disable transition on the track element
     * @param {boolean} enabled - Whether to enable (true) or disable (false) transition
     */
    setTransition(enabled) {
      this.#track.style.transition = enabled ? `transform ${this.DURATION}ms ${this.EASING}` : 'none';
    }
    advance() {
      this.#current++;

      this.setTransition(true);
      this.#track.style.transform = `translateY(-${(this.#current * 100) / this.#slides.length}%)`;

      // Once animated into the clone, snap back to real slide 0
      if (this.#current === this.#slides.length - 1) {
        setTimeout(() => {
          this.setTransition(false);
          this.#track.style.transform = 'translateY(0%)';
          this.#current = 0;
        }, this.DURATION);
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-geolocator"]) return;
  try {
    
// Section-Builder: geolocate.js
class GeoPopup extends HTMLElement {
  #endpoint = "https://ipgeolocator.wilymonkey.dev";
  #storageKey = "ip-geolocator:choice-made";
  #dialog;
  /** @type {Map<string, string>} */
  #urlMap = new Map();

  constructor() {
    super();
    this.#dialog = /** @type {HTMLDialogElement} */ (
      this.throw.element("dialog")
    );
    this.throw.any("[data-url][data-id]").forEach((element) => {
      const id = element.dataset.id;
      const url = element.dataset.url;
      if (!id || !url) {
        throw Error(`[IP-Geolocator]: ID: ${id} and/or ${url} is invalid`);
      }

      this.#urlMap.set(id, url);
    });
  }

  connectedCallback() {
    // The user already made a choice (or never needed the dialog): skip the IP lookup entirely.
    if (this.hasMadeChoice()) return;
    this.fetchGeoInfo();
  }

  /**
   * RETRIEVE: has the user already made a choice about which store to use?
   * @returns {boolean}
   */
  hasMadeChoice() {
    try {
      return localStorage.getItem(this.#storageKey) === "true";
    } catch (err) {
      // localStorage can be blocked (private mode, etc.). Treat as "no choice yet".
      console.error(`[IP-Geolocator]: could not read choice: ${err}`);
      return false;
    }
  }

  /**
   * STORE: remember that the user made a choice (or that no dialog was needed).
   */
  saveChoice() {
    try {
      localStorage.setItem(this.#storageKey, "true");
    } catch (err) {
      console.error(`[IP-Geolocator]: could not save choice: ${err}`);
    }
  }

  /**
   * @param {string} state
   * @returns {string | null} the url the user should be directed to, or null if they're already in the right store.
   */
  redirectTo(state) {
    const current = window.location.hostname;
    const target = this.#urlMap.get(state);
    if (!target) {
      throw Error(`[IP-Geolocator]: State ${state} is not in #urlMap`);
    }

    if (target !== current) {
      return "https://" + target;
    }
    return null;
  }

  async fetchGeoInfo() {
    let state;
    try {
      const res = await fetch(this.#endpoint);
      if (!res.ok) throw Error(`HTTP ${res.status}`);
      state = (await res.text()).trim();
    } catch (err) {
      // Lookup failed: don't save anything so we can try again next visit.
      console.error(`[IP-Geolocator]: ${err}`);
      return;
    }

    // No usable location: nothing to act on, and nothing worth remembering.
    if (!state || state === "MISS") return;

    let url = this.redirectTo(state);
    if (!url) {
      // User is already in the correct store, no dialog needed.
      this.saveChoice();
      return;
    }

    this.dispatchEvent(
      new CustomEvent("geo-resolved", {
        detail: { location: state, url },
        bubbles: true,
      }),
    );
    this.handleOpen();
  }

  /**
   * @param {Event} event - The cancel or popstate event.
   */
  #preventClose = (event) => {
    event.preventDefault();
    this.handleClose();
  };

  /**
   * @param {Event} event
   */
  #onDialogClick = (event) => {
    if (event.target === this.#dialog) {
      this.handleClose();
    }
  };

  handleOpen() {
    this.#dialog.showModal();
    history.pushState({ modal: true }, "", window.location.href);
    window.addEventListener("popstate", this.#preventClose);
    document.body.addEventListener("cancel", this.#preventClose);
    this.#dialog.addEventListener("click", this.#onDialogClick);
  }

  handleClose() {
    this.#dialog.close();
    window.removeEventListener("popstate", this.#preventClose);
    document.body.removeEventListener("cancel", this.#preventClose);
    this.#dialog.removeEventListener("click", this.#onDialogClick);

    // The user interacted with the dialog, so don't ask again.
    this.saveChoice();

    // Only go back if there's a modal state
    if (history.state?.modal) {
      history.back();
    }
  }
}

customElements.define("geo-popup", GeoPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navbar-drawer"]) return;
  try {
    
// Section-Builder: 01-main.js
class NavbarDrawer extends HTMLElement {
    #popup;
    #popupSurface;
    #boundPreventClose; // Store the bound version so we can remove it later

    constructor() {
      super();
      this.#popup = /** @type {HTMLDialogElement} */ (this.throw.element('dialog'));
      this.#popupSurface = this.throw.element('[data-name="popup-surface"]');

      // Fix: Force 'this' to always refer to the NavbarDrawer instance
      this.#boundPreventClose = this.#preventClose.bind(this);
    }

    open() {
      this.#popup.showModal();
      requestAnimationFrame(() => {
        this.#popupSurface.setAttribute('data-show', '');
      });

      // Push the state so the back button closes the drawer instead of leaving the page
      history.pushState({ modal: true }, '', window.location.href);

      // Use the bound version here
      window.addEventListener('popstate', this.#boundPreventClose);
      document.body.addEventListener('cancel', this.#boundPreventClose);
    }

    /** Prevents the popup from closing when the user cancels or pops the history state.
     *
     * @param {Event} event - The cancel or popstate event.
     */
    #preventClose(event) {
      event.preventDefault();
      this.close();
    }

    close() {
      this.#popupSurface.removeAttribute('data-show');
      this.#popupSurface.addEventListener('transitionend', () => this.#popup.close(), {
        once: true,
      });

      // Use the bound version here to successfully clean up
      window.removeEventListener('popstate', this.#boundPreventClose);
      document.body.removeEventListener('cancel', this.#boundPreventClose);

      // Only go back if there's an active modal state left in history
      if (history.state?.modal) {
        history.back();
      }
    }
  }

  customElements.define('navbar-drawer', NavbarDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-search"]) return;
  try {
    
// Section-Builder: 01-main.js
class HeaderSearch extends HTMLElement {
  #popup;
  #popupSurface;
  #boundPreventClose; // Store the bound version so we can remove it later
  #boundBackdropClick;

  constructor() {
    super();
    this.#popup = /** @type {HTMLDialogElement} */ (
      this.throw.element("dialog")
    );
    this.#popupSurface = this.throw.element('[data-name="popup-surface"]');

    // Fix: Force 'this' to always refer to the NavbarDrawer instance
    this.#boundPreventClose = this.#preventClose.bind(this);
    this.#boundBackdropClick = this.#backdropClick.bind(this);
  }
  /** Prevents the popup from closing when the user clicks the backdrop.
   *
   * @param {Event} e - The cancel or popstate event.
   */
  #backdropClick(e) {
    if (e.target === this.#popup) {
      this.#preventClose(e);
    }
  }

  open() {
    this.#popup.showModal();
    this.#popup.focus(); // Prevent autofocus on input.
    requestAnimationFrame(() => {
      this.#popupSurface.setAttribute("data-show", "");
    });

    // Push the state so the back button closes the drawer instead of leaving the page
    history.pushState({ modal: true }, "", window.location.href);

    this.addEventListener("click", this.#boundBackdropClick);
    window.addEventListener("popstate", this.#boundPreventClose);
    document.body.addEventListener("cancel", this.#boundPreventClose);
  }

  /** Prevents the popup from closing when the user cancels or pops the history state.
   *
   * @param {Event} event - The cancel or popstate event.
   */
  #preventClose(event) {
    event.preventDefault();
    this.close();
  }

  close() {
    this.#popupSurface.removeAttribute("data-show");
    this.#popupSurface.addEventListener(
      "transitionend",
      () => this.#popup.close(),
      {
        once: true,
      },
    );

    // Use the bound version here to successfully clean up
    this.removeEventListener("click", this.#boundBackdropClick);
    window.removeEventListener("popstate", this.#boundPreventClose);
    document.body.removeEventListener("cancel", this.#boundPreventClose);

    // Only go back if there's an active modal state left in history
    if (history.state?.modal) {
      history.back();
    }
  }
}

customElements.define("header-search", HeaderSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-immersive-image"]) return;
  try {
    
// Section-Builder: 01-main.js
// ---------------------------------------------------------------------------
  // Carousel Strip
  // ---------------------------------------------------------------------------

  class CarouselStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.interval = parseInt(this.dataset.interval || '3000', 10);

      // real slide count (before cloning)
      this.realCount = this.track.children.length;

      // clone first and last slide for seamless infinite wrap
      const first = this.track.children[0].cloneNode(true);
      const last = this.track.children[this.realCount - 1].cloneNode(true);
      this.track.appendChild(first);
      this.track.insertBefore(last, this.track.children[0]);

      // index 1 = first real slide (index 0 is the cloned "last")
      this.index = 1;
      this.paused = false;
      this.dragging = false;
      this.startX = 0;
      this.dragOffset = 0;

      this._setupTrack();
      this._bindEvents();
      this._resetAutoplay();

      window.addEventListener('resize', () => this._jumpTo(this.index, false));
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
    }

    _setupTrack() {
      this.track.style.willChange = 'transform';
      this._jumpTo(this.index, false);
    }

    get slideWidth() {
      return this.getBoundingClientRect().width;
    }

    _jumpTo(index, animate = true) {
      this.track.style.transition = animate ? 'transform 400ms ease' : 'none';
      this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
    }

    _next() {
      if (this.dragging) return;
      this.index++;
      this._jumpTo(this.index, true);

      // if we've landed on the cloned last slide, snap back invisibly
      if (this.index === this.track.children.length - 1) {
        this.track.addEventListener(
          'transitionend',
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }
    }

    _resetAutoplay() {
      clearInterval(this._timer);
      if (!this.paused) {
        this._timer = setInterval(() => this._next(), this.interval);
      }
    }

    _pauseThenResume() {
      this.paused = true;
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => {
        this.paused = false;
        this._resetAutoplay();
      }, this.interval);
    }

    _bindEvents() {
      this.addEventListener('mouseenter', () => {
        this.paused = true;
        clearInterval(this._timer);
      });
      this.addEventListener('mouseleave', () => {
        this.paused = false;
        this._resetAutoplay();
      });

      this.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        this.dragging = true;
        this.paused = true;
        clearInterval(this._timer);
        this.startX = e.clientX;
        this.track.style.transition = 'none';
        this.style.cursor = 'grabbing';
        this.setPointerCapture(e.pointerId);
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        this.dragOffset = e.clientX - this.startX;
        const base = -this.index * this.slideWidth;
        this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.style.cursor = 'grab';

        const threshold = this.slideWidth * 0.2;
        if (this.dragOffset < -threshold) {
          this.index++;
        } else if (this.dragOffset > threshold) {
          this.index--;
        }
        this.dragOffset = 0;
        this._jumpTo(this.index, true);

        // handle wrap-around after manual swipe
        const lastIdx = this.track.children.length - 1;
        if (this.index === lastIdx) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = 1;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        } else if (this.index === 0) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = this.realCount;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        }

        this._pauseThenResume();
      };

      this.addEventListener('pointerup', endDrag);
      this.addEventListener('pointercancel', endDrag);
      this.addEventListener('pointerleave', endDrag);
    }
  }

  customElements.define('carousel-strip', CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-immersive-video"]) return;
  try {
    
// Section-Builder: 01-main.js
// ---------------------------------------------------------------------------
  // Carousel Strip
  // ---------------------------------------------------------------------------

  class CarouselStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.interval = parseInt(this.dataset.interval || '3000', 10);

      // real slide count (before cloning)
      this.realCount = this.track.children.length;

      // clone first and last slide for seamless infinite wrap
      const first = this.track.children[0].cloneNode(true);
      const last = this.track.children[this.realCount - 1].cloneNode(true);
      this.track.appendChild(first);
      this.track.insertBefore(last, this.track.children[0]);

      // index 1 = first real slide (index 0 is the cloned "last")
      this.index = 1;
      this.paused = false;
      this.dragging = false;
      this.startX = 0;
      this.dragOffset = 0;

      this._setupTrack();
      this._bindEvents();
      this._resetAutoplay();

      window.addEventListener('resize', () => this._jumpTo(this.index, false));
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
    }

    _setupTrack() {
      this.track.style.willChange = 'transform';
      this._jumpTo(this.index, false);
    }

    get slideWidth() {
      return this.getBoundingClientRect().width;
    }

    _jumpTo(index, animate = true) {
      this.track.style.transition = animate ? 'transform 400ms ease' : 'none';
      this.track.style.transform = `translate3d(${-index * this.slideWidth}px, 0, 0)`;
    }

    _next() {
      if (this.dragging) return;
      this.index++;
      this._jumpTo(this.index, true);

      // if we've landed on the cloned last slide, snap back invisibly
      if (this.index === this.track.children.length - 1) {
        this.track.addEventListener(
          'transitionend',
          () => {
            this.index = 1;
            this._jumpTo(this.index, false);
          },
          { once: true },
        );
      }
    }

    _resetAutoplay() {
      clearInterval(this._timer);
      if (!this.paused) {
        this._timer = setInterval(() => this._next(), this.interval);
      }
    }

    _pauseThenResume() {
      this.paused = true;
      clearInterval(this._timer);
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => {
        this.paused = false;
        this._resetAutoplay();
      }, this.interval);
    }

    _bindEvents() {
      this.addEventListener('mouseenter', () => {
        this.paused = true;
        clearInterval(this._timer);
      });
      this.addEventListener('mouseleave', () => {
        this.paused = false;
        this._resetAutoplay();
      });

      this.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        this.dragging = true;
        this.paused = true;
        clearInterval(this._timer);
        this.startX = e.clientX;
        this.track.style.transition = 'none';
        this.style.cursor = 'grabbing';
        this.setPointerCapture(e.pointerId);
      });

      this.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        this.dragOffset = e.clientX - this.startX;
        const base = -this.index * this.slideWidth;
        this.track.style.transform = `translate3d(${base + this.dragOffset}px, 0, 0)`;
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.style.cursor = 'grab';

        const threshold = this.slideWidth * 0.2;
        if (this.dragOffset < -threshold) {
          this.index++;
        } else if (this.dragOffset > threshold) {
          this.index--;
        }
        this.dragOffset = 0;
        this._jumpTo(this.index, true);

        // handle wrap-around after manual swipe
        const lastIdx = this.track.children.length - 1;
        if (this.index === lastIdx) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = 1;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        } else if (this.index === 0) {
          this.track.addEventListener(
            'transitionend',
            () => {
              this.index = this.realCount;
              this._jumpTo(this.index, false);
            },
            { once: true },
          );
        }

        this._pauseThenResume();
      };

      this.addEventListener('pointerup', endDrag);
      this.addEventListener('pointercancel', endDrag);
      this.addEventListener('pointerleave', endDrag);
    }
  }

  customElements.define('carousel-strip', CarouselStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-photo-cake"]) return;
  try {
    
// Section-Builder: 01-main.js
/**
   * Custom element that applies perspective (corner-based) warps and optional
   * rotation to all <img data-corners="..."> elements on the page.
   *
   * Usage:
   *   <image-matrix-calculator></image-matrix-calculator>
   * The element itself is invisible; it only performs the initialisation work.
   */
  class ImageMatrixCalculator extends HTMLElement {
    /** @type {ResizeObserver | null} */
    #resizeObserver = null;

    /**
     * Called when the element is inserted into the DOM.
     * Locates all target images and sets up resize observation.
     */
    connectedCallback() {
      const images = document.querySelectorAll('img[data-corners]');
      if (!images.length) return;

      // Apply warp immediately
      images.forEach((img) => this.applyWarp(/** @type {HTMLImageElement} */ (img)));

      // Fires on initial layout, viewport resize, breakpoint changes,
      // and when a previously hidden (display:none) element becomes visible.
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.applyWarp(/** @type {HTMLImageElement} */ (entry.target));
        }
      });
      images.forEach((img) => observer.observe(img));
      this.#resizeObserver = observer; // keep a reference for cleanup
    }

    /**
     * Clean up observers / listeners when the element is removed.
     */
    disconnectedCallback() {
      if (this.#resizeObserver) {
        this.#resizeObserver.disconnect();
        this.#resizeObserver = null;
      }
    }

    /**
     * @typedef {Object} Point
     * @property {number} x
     * @property {number} y
     */

    /**
     * @typedef {Object} Corners
     * @property {Point} tl Top-left corner offset
     * @property {Point} tr Top-right corner offset
     * @property {Point} bl Bottom-left corner offset
     * @property {Point} br Bottom-right corner offset
     */

    /**
     * Converts four corner offsets into a CSS matrix3d() transform that maps
     * the unit square [0,w]×[0,h] onto the given quadrilateral.
     *
     * @param {number} w Image width in pixels
     * @param {number} h Image height in pixels
     * @param {Corners} corners Absolute pixel offsets for each corner (relative to the un-transformed image).
     * @returns {string} A complete CSS `matrix3d(...)` value.
     */
    cornersToMatrix3d(w, h, corners) {
      const p0 = { x: corners.tl.x, y: corners.tl.y };
      const p1 = { x: w + corners.tr.x, y: corners.tr.y };
      const p2 = { x: w + corners.br.x, y: h + corners.br.y };
      const p3 = { x: corners.bl.x, y: h + corners.bl.y };

      const { x: x0, y: y0 } = p0;
      const { x: x1, y: y1 } = p1;
      const { x: x2, y: y2 } = p2;
      const { x: x3, y: y3 } = p3;

      const dx1 = x1 - x2;
      const dx2 = x3 - x2;
      const dx3 = x0 - x1 + x2 - x3;
      const dy1 = y1 - y2;
      const dy2 = y3 - y2;
      const dy3 = y0 - y1 + y2 - y3;

      let a, b, c, d, e, f, g, hh, i;

      // Affine case (no perspective)
      if (Math.abs(dx3) < 1e-9 && Math.abs(dy3) < 1e-9) {
        a = x1 - x0;
        b = x2 - x1;
        c = x0;
        d = y1 - y0;
        e = y2 - y1;
        f = y0;
        g = 0;
        hh = 0;
        i = 1;
      } else {
        // Full projective case
        const denom = dx1 * dy2 - dx2 * dy1;
        g = (dx3 * dy2 - dx2 * dy3) / denom;
        hh = (dx1 * dy3 - dx3 * dy1) / denom;
        a = x1 - x0 + g * x1;
        b = x3 - x0 + hh * x3;
        c = x0;
        d = y1 - y0 + g * y1;
        e = y3 - y0 + hh * y3;
        f = y0;
        i = 1;
      }

      // Normalise by image dimensions so the transform is independent of size
      const a2 = a / w;
      const b2 = b / h;
      const c2 = c;
      const d2 = d / w;
      const e2 = e / h;
      const f2 = f;
      const g2 = g / w;
      const h2 = hh / h;
      const i2 = i;

      return `matrix3d(${a2},${d2},0,${g2}, ${b2},${e2},0,${h2}, 0,0,1,0, ${c2},${f2},0,${i2})`;
    }

    /**
     * Reads data-corners / data-rotation from an image and applies the
     * corresponding CSS transform.
     *
     * @param {HTMLImageElement} img
     */
    applyWarp(img) {
      const w = img.offsetWidth;
      const h = img.offsetHeight;
      if (!w || !h) return; // still hidden or not laid out

      /** @type {Record<string, {x?: number, y?: number}>} */
      let pct;
      try {
        pct = JSON.parse(img.dataset.corners ?? '{}');
      } catch {
        return; // malformed JSON – silently ignore
      }

      const corners = {
        tl: { x: 0, y: 0 },
        tr: { x: 0, y: 0 },
        bl: { x: 0, y: 0 },
        br: { x: 0, y: 0 },
      };

      for (const key of /** @type {const} */ (['tl', 'tr', 'bl', 'br'])) {
        const c = pct[key] ?? { x: 0, y: 0 };
        corners[key] = {
          x: ((c.x ?? 0) / 100) * w,
          y: ((c.y ?? 0) / 100) * h,
        };
      }

      img.style.transformOrigin = '0 0';
      img.style.transform = this.cornersToMatrix3d(w, h, corners);
    }
  }

  customElements.define('image-matrix-calculator', ImageMatrixCalculator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-brand-cupcakes"]) return;
  try {
    
// Section-Builder: 01-main.js
class CupcakeTurnPicker extends HTMLElement {
    static MOBILE_QUERY = '(max-width: 767px)';
    static MOBILE_MAX_INDEX = 2; // first 3 items = index 0,1,2
    #mql;
    #cupcakes;
    #mobileOnly;
    #prev = /** @type {HTMLElement | null} */ (null);
    #tickerId;

    constructor() {
      super();
      this.#mql = window.matchMedia(CupcakeTurnPicker.MOBILE_QUERY);
      this.#cupcakes = this.throw.any('[data-bucket]');
      this.#mobileOnly = this.#cupcakes.filter((el) => {
        const attr = el.getAttribute('data-bucket');
        return attr === '1' || attr === '2';
      });
      this.#tickerId = setInterval(async () => {
        this.pickTurn();
      }, 3000);
    }

    disconnectedCallback() {
      clearInterval(this.#tickerId);
    }

    async pickTurn() {
      if (this.#prev) this.#prev.toggleAttribute('data-turn', false);
      const isMobile = this.#mql.matches;
      if (isMobile) {
        const chosen = this.#mobileOnly[Math.floor(Math.random() * this.#mobileOnly.length)];
        chosen.toggleAttribute('data-turn', true);
        return;
      }

      const chosen = this.#cupcakes[Math.floor(Math.random() * this.#cupcakes.length)];
      chosen.toggleAttribute('data-turn', true);
      this.#prev = chosen;
    }
  }

  customElements.define('cupcake-turn-picker', CupcakeTurnPicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-scrolling-images"]) return;
  try {
    
// Section-Builder: parallax-scroller.js
class ParallaxScroller extends HTMLElement {
  #buckets;
  #mq;
  #maxOffset = 80;
  #maxOffsetDesktop = 160;
  #ticking = false;
  #reduceMotion = false;
  #bucketConfig;

  /** @type {IntersectionObserver | null} */
  #io = null;
  /** @type {(event?: Event) => void} */
  #onScroll;
  /** @type {() => void} */
  #update;

  constructor() {
    super();

    this.#buckets = Array.from(this.throw.any("[data-parallax]"));
    this.#bucketConfig = new Map(
      this.#buckets.map((bucket) => [
        bucket,
        this.#resolveBucketConfig(bucket),
      ]),
    );
    const breakpoint = parseFloat(this.getAttribute("data-breakpoint")) || 768;
    this.#mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
    this.#ticking = false;
    this.#reduceMotion = false;
    this.#io = null;

    this.#onScroll = this.#handleScroll.bind(this);
    this.#update = this.#handleUpdate.bind(this);
  }

  connectedCallback() {
    this.#io = new IntersectionObserver(
      (entries) => {
        const active = entries[0].isIntersecting;
        if (active) {
          window.addEventListener("scroll", this.#onScroll, { passive: true });
          window.addEventListener("resize", this.#onScroll, { passive: true });
          this.#onScroll();
        } else {
          window.removeEventListener("scroll", this.#onScroll);
          window.removeEventListener("resize", this.#onScroll);
        }
      },
      { rootMargin: "20% 0px 20% 0px" },
    );
    this.#io.observe(this);

    // Respect reduced-motion preference.
    this.#reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (this.#reduceMotion) return;

    this.#update();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onScroll);
    window.removeEventListener("resize", this.#onScroll);
    if (this.#io) this.#io.disconnect();
  }

  /**
   * Throttled scroll/resize handler; schedules a single rAF update.
   * @param {Event} [_event]
   * @returns {void}
   */
  #handleScroll(_event) {
    if (this.#reduceMotion || this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(this.#update);
  }

  /**
   * Reads a bucket's static data-attributes once and normalizes them into a config object.
   *
   * @typedef {Object} AxisConfig
   * @property {string} axis - The movement axis.
   * @property {number} dir - The direction multiplier (-1 or 1).
   *
   * @typedef {Object} BucketConfig
   * @property {AxisConfig | null} desktop - Configuration for desktop breakpoint, or null if invalid.
   * @property {AxisConfig | null} mobile - Configuration for mobile breakpoint, or null if invalid.
   *
   * @param {HTMLElement} bucket - The bucket element containing static data attributes.
   * @returns {BucketConfig} The normalized breakpoint configuration object.
   */
  #resolveBucketConfig(bucket) {
    /** @param {string|undefined} axis @param {string|undefined} dirAttr */
    const normalize = (axis, dirAttr) => {
      const dir = parseFloat(dirAttr ?? "");
      if (axis !== "x" && axis !== "y") return null;
      if (Number.isNaN(dir)) return null;
      return { axis, dir };
    };

    return {
      desktop: normalize(bucket.dataset.desktopAxis, bucket.dataset.desktopDir),
      mobile: normalize(bucket.dataset.mobileAxis, bucket.dataset.mobileDir),
    };
  }

  /**
   * Computes scroll progress and applies transforms to each bucket.
   * @returns {void}
   */
  #handleUpdate() {
    this.#ticking = false;

    const rect = this.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const total = vh + rect.height;

    // 0 = component just entering from bottom, 1 = fully scrolled past top.
    let progress = (vh - rect.top) / total;
    progress = Math.min(1, Math.max(0, progress));

    // -1 .. 1, centered at the midpoint of the scroll-through.
    const centered = (progress - 0.5) * 2;
    const isDesktop = this.#mq.matches;

    this.#buckets.forEach((bucket) => {
      const config = this.#bucketConfig.get(bucket);
      const active = isDesktop ? config?.desktop : config?.mobile;

      if (!active) {
        bucket.style.transform = "";
        return;
      }
      const maxOffset = isDesktop ? this.#maxOffsetDesktop : this.#maxOffset;

      const offset = centered * maxOffset * active.dir;
      bucket.style.transform =
        active.axis === "x"
          ? `translate3d(${offset}px,0,0)`
          : `translate3d(0,${offset}px,0)`;
    });
  }
}

customElements.define("parallax-scroller", ParallaxScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-judgeme"]) return;
  try {
    
// Section-Builder: 01-main.js
class JudgeMeReviews extends HTMLElement {
    static get observedAttributes() {
      return ['shop-domain', 'product-id', 'per-page'];
    }

    constructor() {
      super();
      this._page = 1;
      this._loading = false;
      this._loadingMore = false;
      this._totalCount = null;
      this._loadedCount = 0;
    }

    connectedCallback() {
      this._render();
      this._fetchPage(1);
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (oldVal === newVal) return;
      if (this.isConnected) {
        this._page = 1;
        this._loadedCount = 0;
        this._render();
        this._fetchPage(1);
      }
    }

    get shopDomain() {
      return this.getAttribute('shop-domain');
    }
    get productId() {
      return this.getAttribute('product-id');
    }
    get perPage() {
      return parseInt(this.getAttribute('per-page') || '5', 10);
    }

    _apiUrl(page) {
      const shop = encodeURIComponent(this.shopDomain);
      const pid = encodeURIComponent(this.productId);
      const per = this.perPage;
      return `https://api.judge.me/reviews/reviews_for_widget?url=${shop}&shop_domain=${shop}&platform=shopify&page=${page}&per_page=${per}&product_id=${pid}`;
    }

    async _fetchPage(page, { append = false } = {}) {
      if (append) {
        if (this._loadingMore || this._loading || !this._hasMore()) return;
        this._loadingMore = true;
        this._setLoadingState(true);
      } else {
        if (this._loading) return;
        this._setLoadingState(true);
      }

      try {
        const res = await fetch(this._apiUrl(page));
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        this._totalCount = data.total_count ?? this._totalCount;
        this._page = parseInt(data.page || page, 10);
        const parsed = this._parseHtml(data.html || '');
        this._loadedCount += parsed.length;
        this._renderReviews(parsed, { append });
        this._updateScrollButtons();
      } catch (err) {
        this._setStatusError(err.message);
      } finally {
        if (append) {
          this._loadingMore = false;
          this._setLoadingState(false);
        } else {
          this._setLoadingState(false);
        }
      }
    }

    _hasMore() {
      return this._totalCount == null || this._loadedCount < this._totalCount;
    }

    _setLoadingState(isLoading) {
      this._loading = isLoading;
      if (this._bodyEl) {
        this._bodyEl.toggleAttribute('data-loading', isLoading);
      }
    }

    _parseHtml(htmlString) {
      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const nodes = Array.from(doc.querySelectorAll('.jdgm-rev'));
      return nodes.map((node) => {
        const score = parseInt(
          node.querySelector('.jdgm-rev__rating')?.getAttribute('data-score') ||
            '0',
          10,
        );
        const author =
          node.querySelector('.jdgm-rev__author')?.textContent.trim() ||
          'Anonymous';
        const timestampEl = node.querySelector('.jdgm-rev__timestamp');
        const timestamp = timestampEl?.getAttribute('data-content') || '';
        const title =
          node.querySelector('.jdgm-rev__title')?.textContent.trim() || '';
        const body =
          node.querySelector('.jdgm-rev__body')?.textContent.trim() || '';
        const verified = node.getAttribute('data-verified-buyer') === 'true';
        const pics = Array.from(
          node.querySelectorAll('.jdgm-rev__pics img'),
        ).map((img) => img.getAttribute('src'));
        return { score, author, timestamp, title, body, verified, pics };
      });
    }

    _formatDate(iso) {
      if (!iso) return '';
      const d = new Date(iso.replace(' ', 'T').replace(' UTC', 'Z'));
      if (isNaN(d)) return iso;
      return d.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    }

    _renderStars(container, score) {
      container.innerHTML = '';
      for (let i = 0; i < 5; i++) {
        const star = document.createElement('span');
        star.className = `${i < score ? 'text-amber-400' : 'text-gray-200'} text-sm`;
        star.textContent = '★';
        container.appendChild(star);
      }
    }

    _render() {
      this._bodyEl = this.querySelector('[data-name="body"]');
      this._cardsEl = this.querySelector('[data-name="cards"]');
      this._cardTemplate = this.querySelector('[data-name="card-template"]');
      this._errorStatusEl = this.querySelector('[data-name="status-error"]');
      this._emptyStatusEl = this.querySelector('[data-name="status-empty"]');

      this._scrollPrevBtn = this.querySelector('[data-name="scroll-prev"]');
      this._scrollNextBtn = this.querySelector('[data-name="scroll-next"]');

      // Carousel scroll controls (scroll through the currently loaded cards)
      if (this._scrollPrevBtn && this._cardsEl) {
        this._scrollPrevBtn.addEventListener('click', () => {
          this._cardsEl.scrollBy({
            left: -this._cardStep(),
            behavior: 'smooth',
          });
        });
      }

      if (this._scrollNextBtn && this._cardsEl) {
        this._scrollNextBtn.addEventListener('click', () => {
          this._cardsEl.scrollBy({
            left: this._cardStep(),
            behavior: 'smooth',
          });
          // Give the smooth scroll a moment to land, then check if we need more
          setTimeout(() => this._maybeFetchMore(), 350);
        });
      }

      if (this._cardsEl) {
        this._cardsEl.addEventListener('scroll', () => {
          this._updateScrollButtons();
          this._maybeFetchMore();
        });
      }
    }

    // When the user is nearing/at the last loaded card, fetch and append the next page
    _maybeFetchMore() {
      if (!this._cardsEl || !this._hasMore()) return;
      const el = this._cardsEl;
      const remaining = el.scrollWidth - el.clientWidth - el.scrollLeft;
      if (remaining <= this._cardStep() * 0.5) {
        this._fetchPage(this._page + 1, { append: true });
      }
    }

    _cardStep() {
      const firstCard = this._cardsEl?.querySelector(
        '[data-name]:not([data-name="card-template"])',
      );
      if (!firstCard) return 300;
      const style = getComputedStyle(this._cardsEl);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    }

    _updateScrollButtons() {
      if (!this._cardsEl) return;
      const el = this._cardsEl;
      const maxScroll = el.scrollWidth - el.clientWidth;

      if (this._scrollPrevBtn) {
        this._scrollPrevBtn.disabled = el.scrollLeft <= 1;
      }
      if (this._scrollNextBtn) {
        this._scrollNextBtn.disabled =
          el.scrollLeft >= maxScroll - 1 && !this._hasMore();
      }
    }

    _setStatusError(msg) {
      if (this._errorStatusEl) {
        this._errorStatusEl.textContent = `Failed to load reviews: ${msg}`;
        this._errorStatusEl.classList.remove('hidden');
      }
    }

    _renderReviews(reviews, { append = false } = {}) {
      if (this._errorStatusEl) this._errorStatusEl.classList.add('hidden');
      if (this._emptyStatusEl) this._emptyStatusEl.classList.add('hidden');

      if (!append) {
        // Remove previously rendered cards, keeping only the template node
        Array.from(this._cardsEl.children).forEach((child) => {
          if (child !== this._cardTemplate) {
            child.remove();
          }
        });

        // Reset scroll position for the new set of cards
        this._cardsEl.scrollTo({ left: 0 });

        if (!reviews.length) {
          if (this._emptyStatusEl)
            this._emptyStatusEl.classList.remove('hidden');
          return;
        }
      } else if (!reviews.length) {
        return;
      }

      if (!this._cardTemplate) return;

      reviews.forEach((r) => {
        const card = this._cardTemplate.cloneNode(true);
        card.removeAttribute('data-name');
        card.classList.remove('hidden');

        // Avatar
        const avatar = card.querySelector('[data-name="avatar"]');
        if (avatar) avatar.textContent = (r.author[0] || '?').toUpperCase();

        // Author
        const author = card.querySelector('[data-name="author"]');
        if (author) author.textContent = r.author;

        // Verified Badge
        const verified = card.querySelector('[data-name="verified"]');
        if (verified) {
          if (!r.verified) verified.remove();
        }

        // Stars
        const stars = card.querySelector('[data-name="stars"]');
        if (stars) this._renderStars(stars, r.score);

        // Title
        const title = card.querySelector('[data-name="title"]');
        if (title) {
          if (r.title) title.textContent = r.title;
          else title.remove();
        }

        // Body
        const body = card.querySelector('[data-name="review-body"]');
        if (body) {
          if (r.body) body.textContent = r.body;
          else body.remove();
        }

        // Pictures
        const pics = card.querySelector('[data-name="pics"]');
        if (pics) {
          if (r.pics && r.pics.length) {
            pics.innerHTML = '';
            r.pics.forEach((src) => {
              const img = document.createElement('img');
              img.src = src;
              img.loading = 'lazy';
              img.className = 'w-14 h-14 object-cover rounded-md';
              pics.appendChild(img);
            });
          } else {
            pics.remove();
          }
        }

        // Date
        const date = card.querySelector('[data-name="date"]');
        if (date) date.textContent = this._formatDate(r.timestamp);

        this._cardsEl.appendChild(card);
      });

      this._updateScrollButtons();
    }
  }

  customElements.define('judgeme-reviews', JudgeMeReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-moving-images"]) return;
  try {
    
// Section-Builder: 01-main.js
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-snap-background-color]');
    const defaultColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--color-background-workaround')
      .trim();

    const intersecting = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const ratio = entry.intersectionRatio;

          if (ratio >= 0.8) {
            // Section is dominant — activate it
            intersecting.add(entry.target);
          } else if (ratio < 0.1) {
            // Section has nearly left — deactivate it
            intersecting.delete(entry.target);
          }
          // Between 0.1–0.8: do nothing, hold current state
        });

        if (intersecting.size > 0) {
          const active = [...intersecting].at(-1);
          const color = active.getAttribute('data-snap-background-color');
          document.documentElement.style.setProperty(
            '--color-background-workaround',
            color,
          );
        } else {
          document.documentElement.style.setProperty(
            '--color-background-workaround',
            defaultColor,
          );
        }
      },
      {
        threshold: [0, 0.1, 0.8, 1.0],
      },
    );

    sections.forEach((el) => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-video-carousel"]) return;
  try {
    
// Section-Builder: 01-main.js
class VideoCarousel extends HTMLElement {
    #sectionVisible = false;
    #activeIndex = 0;
    #io = /** @type {IntersectionObserver | null} */ (null);
    #scrollEndTimer = null;
    #onClick = null;
    #onScroll = null;
    #onScrollEnd = null;

    connectedCallback() {
      const activeIndex = this.getAttribute('data-active');
      if (activeIndex) {
        this.#activeIndex = parseInt(activeIndex);
        this.activate(activeIndex, { scroll: true });
      } else {
        this.#activeIndex = this.calculateInitialActiveIndex();
      }
      this.setupSectionObserver();
      this.setupClickHandlers();
      this.setupSwipeHandlers();
    }

    disconnectedCallback() {
      if (this.#io) this.#io.disconnect();
      if (this.#onScroll) this.removeEventListener('scroll', this.#onScroll);
      if (this.#onScrollEnd)
        this.removeEventListener('scrollend', this.#onScrollEnd);
      if (this.#scrollEndTimer) clearTimeout(this.#scrollEndTimer);
    }

    get cards() {
      return Array.from(this.querySelectorAll('.video-card'));
    }

    calculateInitialActiveIndex() {
      const cards = this.cards;
      const defaultIndex = cards.findIndex(
        (card) => card.dataset.default === 'true',
      );
      return Math.max(0, defaultIndex);
    }

    setupSectionObserver() {
      this.#io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.#sectionVisible = entry.isIntersecting;
            if (this.#sectionVisible) {
              this.playActive();
            } else {
              this.pauseAll();
            }
          });
        },
        { threshold: 0.35 },
      );
      this.#io.observe(this);
    }

    setupClickHandlers() {
      this.#onClick = (e) => {
        const card = e.target.closest('.video-card');
        if (!card) return;
        const index = Number(card.dataset.index);
        this.activate(index, { scroll: true });
      };
      this.addEventListener('click', this.#onClick);
    }

    setupSwipeHandlers() {
      const reel = this.throw.element('[data-name="reel"]');
      this.#onScrollEnd = () => this.handleSwipeSettled();
      reel.addEventListener('scrollend', this.#onScrollEnd);
    }

    handleSwipeSettled() {
      const index = this.findCenteredIndex();
      if (index === -1) return;
      // Already centered by the user's swipe/snap — don't re-trigger a scroll.
      this.activate(index, { scroll: false });
    }

    findCenteredIndex() {
      const cards = this.cards;
      if (!cards.length) return -1;
      const containerRect = this.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;

      let closestIndex = -1;
      let closestDistance = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(cardCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      return closestIndex;
    }

    activate(index, { scroll = false } = {}) {
      if (index === this.#activeIndex) {
        if (scroll) this.centerCard(index);
        return;
      }
      this.pauseAll();
      this.#activeIndex = index;
      this.updateVisualState();
      if (scroll) this.centerCard(index);
      if (this.#sectionVisible) this.playActive();
    }

    centerCard(index) {
      const card = this.cards[index];
      const container = card?.parentElement; // or reference your scroll container directly

      if (card && container) {
        // Distance from the container's left edge to the center of the card
        const targetLeft =
          card.offsetLeft - container.clientWidth / 2 + card.clientWidth / 2;

        container.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      }
    }

    updateVisualState() {
      this.cards.forEach((card, i) => {
        card.toggleAttribute('data-active', i === this.#activeIndex);
      });
    }

    playActive() {
      const card = this.cards[this.#activeIndex];
      if (!card) return;
      this.updateVisualState();
      if (card.dataset.type === 'image') return;
      const video = card.querySelector('[data-role="video"]');
      const source = card.querySelector('[data-role="source"]');
      const poster = card.querySelector('[data-role="poster"]');
      if (!video || !source) return;
      // Load the video source if it hasn't been set yet (lazy load logic)
      if (!source.src && source.dataset.src) {
        source.src = source.dataset.src;
        source.type = source.dataset.videoType;
        video.load();
      }
      const onPlaying = () => {
        video.classList.remove('opacity-0');
        if (poster) poster.classList.add('opacity-0');
        video.removeEventListener('playing', onPlaying);
      };
      video.addEventListener('playing', onPlaying);
      video.play().catch(() => {
        // autoplay blocked or aborted — keep poster visible
        video.classList.add('opacity-0');
        if (poster) poster.classList.remove('opacity-0');
      });
    }

    pauseAll() {
      this.cards.forEach((card) => {
        const video = card.querySelector('[data-role="video"]');
        const poster = card.querySelector('[data-role="poster"]');
        if (video && !video.paused) video.pause();
        if (video) video.classList.add('opacity-0');
        if (poster) poster.classList.remove('opacity-0');
      });
    }
  }
  customElements.define('video-carousel', VideoCarousel);

  } catch(e) { console.error(e); }
})();
})();
